import React from 'react';
import styled, { css } from 'styled-components';
import { Route, Link } from 'react-router-dom';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { Colors } from 'planoplan-ui-kit/core/colors';

export const SidebarButton = ({ to, icon, open, activeOnlyWhenExact, text, render, svg }) => (
  <Route
    path={to}
    exact={activeOnlyWhenExact}
    children={({ match }) => (
      <SidebarButtonView render={render} to={to} active={match ? 'true' : 'false'}>
        {!render && (
          <React.Fragment>
            <Icon open={open} src={icon} alt={text} svg={svg} />
            {open && <Text open={open}>{text}</Text>}
          </React.Fragment>
        )}
        {render && render}
      </SidebarButtonView>
    )}
  />
);

export const SidebarOuterButton = ({ open, icon, text, match, ...restProps }) => (
  <SidebarButtonLinkView active={match ? 'true' : 'false'} {...restProps}>
    <React.Fragment>
      <Icon open={open} src={icon} alt={text} />
      {open && <Text open={open}>{text}</Text>}
    </React.Fragment>
  </SidebarButtonLinkView>
);

const Icon = ({ src, text, open, svg }) => (
  <IconContainer open={open}>{svg ? svg : <img src={src} alt={text} />}</IconContainer>
);
const sidebarButtonCss = css`
  ${Mixins.transition('background-color')};
  display: flex;
  justify-content: ${(p) => (p.render ? 'center' : 'flex-start')};
  align-items: center;
  text-align: center;
  white-space: nowrap;
  border: none;
  height: ${(p) => (p.render ? 'initial' : '44px')};
  width: 100%;
  background-color: ${(p) => (p.active === 'true' ? Colors.azure : Colors.white)};
  cursor: pointer;
  text-decoration: none;
  overflow: hidden;
  color: ${Colors.coal};
  font-size: 16px;

  &:hover {
    background-color: ${Colors.azure};
    color: ${Colors.coal};
  }
`;

const SidebarButtonView = styled(Link)`
  ${sidebarButtonCss}
`;

const SidebarButtonLinkView = styled.a`
  ${sidebarButtonCss}
`;

const IconContainer = styled.div`
  width: 76px;
  min-width: 76px;
  height: 100%;
  display: flex;
  margin-right: ${(p) => (p.open ? '-12px' : '0')};
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const Text = styled.span``;
